<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="80px"
  >
    <el-form-item
      label="用户名"
      prop="roleName"
    >
      <el-input
        placeholder="角色名称"
        v-model="form.roleName"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="remark"
      label="备注"
    >
      <el-input
        placeholder="请输入"
        v-model="form.remark"
      ></el-input>
    </el-form-item>
    <el-row
      :gutter="20"
    >
      <el-col :span="12">
        <el-form-item
          size="mini"
          label="菜单权限"
        >
          <el-tree
            :data="orginMenu"
            :props="menuListTreeProps"
            node-key="menuId"
            ref="orginmenuListTree"
            :default-expand-all="true"
            show-checkbox
          >
          </el-tree>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          size="mini"
          label="按钮权限"
        >
          <el-tree
            :data="menuList"
            :props="menuListTreeProps"
            node-key="menuId"
            ref="menuListTree"
            :default-expand-all="true"
            show-checkbox
          >
          </el-tree>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { treeDataTranslate } from '@/utils/common'
import { queryMenu } from '@/api/sys/menu'

let origin = {
  roleId: '',
  roleName: '',
  remark: '',
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "roleForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {
          userId: ''
        };
      }
    }
  },
  data() {
    return {
      menuList: [],
      orginMenu:[],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        roleName: [
          { required:true, message: '请选择', trigger: 'blur' },
        ],
      },
      menuListTreeProps: {
        label: 'name',
        children: 'children'
      }
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.roleId){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },
  computed: {

  },
  mixins: [formLabalPosition],
  created(){
    this.getMenuList();
  },
  methods: {
    handlerMenuList(list) {
      if(!list.length) return [];
      let filterArr = list.filter((item) => {
        return item.type == 1 || item.type == 0;
      });
      console.log(filterArr);
      return filterArr;
    },
    getMenuList(){
      queryMenu().then((res) => {
        console.log(res);
        let filter = this.handlerMenuList(JSON.parse(JSON.stringify(res)));
        console.log(filter);
        this.orginMenu = treeDataTranslate(filter, 'menuId');
        console.log(this.orginMenu);
        this.menuList = treeDataTranslate(res, 'menuId');

      })
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(roler){
      this.form.roleId = roler.roleId;
      this.form.roleName = roler.roleName;
      this.form.remark = roler.remark;
      roler.menuIdList.forEach(item => {
        this.$refs.menuListTree.setChecked(item, true);
        this.$refs.orginmenuListTree.setChecked(item, true);
      });
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          let menuIdList = this.$refs.menuListTree.getCheckedKeys();
          let originMenuIdList = [].concat(this.$refs.orginmenuListTree.getCheckedKeys(), this.$refs.orginmenuListTree.getHalfCheckedKeys());
          let concatArr = menuIdList.concat(menuIdList,originMenuIdList);
          this.$emit('submit',this.form,concatArr);
        }else {
          console.log('no-pass');
        }
      })
    },
    selfClear(){
      this.$refs.menuListTree.setCheckedKeys([]);
      this.$refs.orginmenuListTree.setCheckedKeys([]);
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
